//===============================================================================================================
// #1 - Base Imports
//===============================================================================================================
import React from "react";

//===============================================================================================================
// #1 - Import * UI Components
//===============================================================================================================
import { Container } from "../../design/layout/container";
//===============================================================================================================
// #1 - Import * Styled Component
//===============================================================================================================
import { Main, Columns, Column as HColumn, ColumnItem as HColumnItem } from "./styles";
import FixedMenu from "../../FixedMenu";

//===============================================================================================================
// #1 - Import * Styled Component
//===============================================================================================================
export const ColumnItem = ({ children }) => <HColumnItem className="column-item"> {children} </HColumnItem>
export const Column = ({ className, children }) => <HColumn className={className}> {children} </HColumn>

function Header({ theme, children }) {

    // * Get Site Props
    const site = {
        carrefour: "carrefour",
        atacadao: "atacadao"
    }

    return (
        <>

            <FixedMenu site={site[theme]} />

            <Main site={site[theme]}>
                <Container withContainer={true}>
                    <Columns>
                        {children}
                    </Columns>
                </Container>
            </Main>
        </>
    )

}

export default Header;